import { loadProtocols } from '../../Notes/Protocols/api/protocol'
import { SearchResult } from '../types/search'

const normalizeText = (value: unknown) =>
  typeof value === 'string' ? value.toLowerCase() : ''

const hasMatch = (query: string, ...values: unknown[]) => {
  const lowerQuery = query.toLowerCase()
  return values.some((value) => normalizeText(value).includes(lowerQuery))
}

export const searchProtocols = async (
  query: string,
  untitledLabel: string,
  userId?: string,
): Promise<SearchResult[]> => {
  const normalizedQuery = query.trim()

  if (!normalizedQuery) {
    return []
  }

  const protocols = await loadProtocols()

  return protocols
    .filter((protocol) => {
      if (
        userId &&
        protocol.createdBy &&
        String(protocol.createdBy) !== String(userId)
      ) {
        return false
      }

      const description =
        typeof protocol.description === 'string' ? protocol.description : ''

      return hasMatch(normalizedQuery, protocol.name, description)
    })
    .map((protocol) => ({
      id: protocol.id,
      title: protocol.name || untitledLabel,
      type: 'protocol' as const,
      path: '/notes/protocols',
      createdAt: protocol.createdAt,
    }))
}
